import { createContext } from 'react'

const contextPlayload = {
  error: false,
  isAuthenticated: false,
  loading: false,
  initialLoading: false,
  signingOut: false,
  login: () => {},
  logout: () => {},
  user: undefined,
}

const AuthProviderContext = createContext(contextPlayload)
AuthProviderContext.displayName = 'AuthProviderContext'

export default AuthProviderContext
